<template>
    <RouterView v-if="!isLoading" :key="route.fullPath" />
    <DotsLoading v-else />
</template>

<script setup>
import { RouterView, useRoute } from 'vue-router';
import { onMounted, ref } from 'vue';

import { useSchedulesStore } from '@@/js/stores/schedules.js';
import DotsLoading from '@/shared/DotsLoading';

const route = useRoute();
const schedulesStore = useSchedulesStore();
const { fetchSchedulesData } = schedulesStore;
const isLoading = ref(true);

onMounted(async () => {
    await fetchSchedulesData();
    isLoading.value = false;
});
</script>
